import React from 'react'

import styles from './Info.module.scss'

const Info = ({ children }) => <div className={styles.info}>{children}</div>

export default Info
